'use client';

import { type ReactNode } from 'react';

import { Button, type ButtonBaseProps } from '@repo/ui/Button';
import { Icon } from '@repo/ui/Icon';
import { type IconNames } from '@repo/ui/Icon/utils';
import { VisuallyHidden } from '@repo/ui/VisuallyHidden';

export interface IconButtonProps extends ButtonBaseProps {
  icon: IconNames;
  label: string | ReactNode;
}

export const IconButton = (props: IconButtonProps) => {
  const {
    disabled = false,
    icon,
    isLoading = false,
    label,
    size = 'md',
    ...attrs
  } = props;

  return (
    <Button
      disabled={disabled}
      isLoading={isLoading}
      size={size}
      variant="icon"
      {...attrs}
    >
      <Icon name={icon} size={size} />
      <VisuallyHidden>{label}</VisuallyHidden>
    </Button>
  );
};
